import { createAction } from 'redux-act';

const ActionTypes = {

    /** 添加加载接口 */
    addLoading: createAction('$$/system/addLoading'),

    /** 删除加载接口 */
    removeLoading: createAction('$$/system/addLoading'),

    /** 更新未读信息 */
    updateUnread: createAction('$$/system/updateUnread'),

    /** 更新菜单APP */
    updateMenuAppList: createAction('$$/system/updateMenuAppList'),

    /** 增加语言版本 */
    addLanguageVersion: createAction('$$/system/addLanguageVersion'),

    /** 设置版本 */
    setVersion: createAction('$$/system/setVersion'),

    /** 设置登录状态 */
    setLoginType: createAction('$$/system/setVersion'),
};

export default ActionTypes;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/system/ActionTypes.ts